import { stateContext } from 'Contexts/StateContext';
import React, { useContext } from 'react';

//@ts-ignore
import { SvgLoader } from 'react-svgmt';

import isEmpty from 'Functions/isEmpty';
import toC from 'Functions/toC';
import toF from 'Functions/toF';

import './Weather.scss';

//prettier-ignore
const Weather = () => {
  const [state] = useContext(stateContext);

  const icon = `assets/${state?.locationData?.weather?.[0]?.icon}.svg`;
  const max = `assets/cloud-arrow-up.svg`
  const min = `assets/cloud-arrow-down.svg`

  return (
    <React.Suspense fallback={<div/>}>
      {!isEmpty(state.locationData) && (
        <>
        <div className="conditions">
          {state.locationData.weather[0].main} /{' '}
          {state.locationData.weather[0].description}
        </div>
          <div className="min-max">
          <div className="weather-icon">
            <SvgLoader
              path={icon}
              className="icon"
              fill="white"
              stroke="black"
              strokeWidth="8px"
            />
            <br />
          </div>
            <br />
            <div className="min-icon">
            <SvgLoader 
            path={min}
            className="icon"
            fill="white"
            stroke="black"
            strokeWidth="12px"
            />
            </div>
            &nbsp;
            {state.imperial ? `${toF(state.locationData.main.temp_min)} °F ` : `${toC(state.locationData.main.temp_min)} °C `}
            -&nbsp;
            <div className="max-icon">
            <SvgLoader 
            path={max}
            className="icon"
            fill="white"
            stroke="black"
            strokeWidth="12px"
            />
            </div>
            &nbsp;
            {state.imperial ? `${toF(state.locationData.main.temp_max)} °F ` : `${toC(state.locationData.main.temp_max)} °C `}
          </div>
          <div className="current-weather">
            Current: {state.imperial ? `${toF(state.locationData.main.temp)} °F ` : `${toC(state.locationData.main.temp)} °C `}
            <br />
            Feels like: {state.imperial ? `${toF(state.locationData.main.feels_like)} °F ` : `${toC(state.locationData.main.feels_like)} °C `}
        </div>
        </>)}
      </React.Suspense>
  );
};

export default Weather;
